import * as React from 'react'
import { Row, Col, Card, Form, Input, Button, Space, Tooltip } from 'antd'

import IoCContainer from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { INotifyService } from '../../services/shared/NotifyService'
import { IAuthenticationService } from '../../services/AuthenticationService'

import info_grey from '../../content/info_grey.svg'
import attention from '../../content/attention.svg'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';


class LoginState {
    mail: string;
    password: string;
    code: string;
    IsAccountVerified: boolean;
    IsCodeRequested: boolean;
    IsCodeRequestedStep1: boolean;
    showTooltipEmail: boolean;
    showTooltipPassword: boolean;
    showPassword: boolean;


    constructor() {
        this.mail = "";
        this.password = "";
        this.code = "";
        this.IsAccountVerified = false;
        this.IsCodeRequested = false;
        this.IsCodeRequestedStep1 = false;
        this.showTooltipEmail = false;
        this.showTooltipPassword = false;
        this.showPassword = false;
    }
    
}


export class PageLogin extends React.Component<any, LoginState> {

    private authenticationService: IAuthenticationService
    private notifyService: INotifyService

    constructor(props) {
        super(props)

        this.state = new LoginState();

        this.authenticationService = IoCContainer.get(SERVICE_IDENTIFIER.AUTHENTICATION_SERVICE);
        this.notifyService = IoCContainer.get(SERVICE_IDENTIFIER.NOTIFY);

        document.title = "Login - MutuoCredem";
    }
    statusRef = React.createRef<HTMLDivElement>();
    statusRichiestaCodice = React.createRef<HTMLDivElement>();


    onHelp = () => {
        throw new Error('Method not implemented.')
    }

    richiediPassword =async () => {
        let resp = await this.authenticationService.RequestPassword(this.state.mail);
        this.setState({ IsCodeRequestedStep1: true })

        if (resp.IsValid === true) {            
            this.notifyService.success("La richiesta è stata inviata correttamente. Riceverai la nuova password entro pochi secondi tramite SMS");
            this.setState({ IsCodeRequestedStep1: false })
            this.statusRichiestaCodice.current.innerHTML = "La richiesta è stata inviata correttamente. Riceverai la nuova password entro pochi secondi tramite SMS";
        } else this.setState({ IsCodeRequestedStep1: false })
    }

    login = async () => {
        var resp = await this.authenticationService.Login(this.state.mail, this.state.password)
        if (resp.IsValid === true) {
            this.setState({ IsAccountVerified: true })
            document.title = "Login - OTP Email";
        }
    }

    verifica2fa = async () => {
        await this.authenticationService.Verifica2fa(this.state.mail, this.state.password, this.state.code)
    }

    request2fa = async () => {
        var resp = await this.authenticationService.Request2FA(this.state.mail)
        if (resp.IsValid) {
            this.setState({ IsCodeRequested: true })
            this.statusRef.current.innerHTML = "Il tuo codice è stato inviato alla mail indicata in fase di login";
        }
    }
    


    render() {
        return (
            <Row>
                <Col lg={{ offset: 7, span: 11 }} sm={{ offset: 6, span: 12 }} xs={{ offset: 2, span: 20 }}>
                    <Card style={{ marginTop: '24px' }}>
                            {!this.state.IsAccountVerified
                            ? <div>
                                <Row>
                                    <Col >
                                        <h1 className="Bold20Credem400" style={{ marginBottom: '20px' }}>Accesso</h1>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col span="24">
                                        <Form layout='vertical'>
                                            <Form.Item htmlFor="mail" label={
                                                <span style={{ display: 'inline-flex', alignItems: 'center'}}>
                                                    <Space>
                                                        <h3 style={{marginTop:'6px'}}>Email</h3>
                                                        <Tooltip title="Inserisci l’indirizzo email che hai fornito al tuo gestore di filiale per l’apertura della richiesta di mutuo" trigger={['hover','focus']}>
                                                            <Button
                                                                type="text"
                                                                icon={<img src={info_grey} height="15" alt="Informazioni sull'email" />}
                                                                tabIndex={0} // Assicura che sia focusable
                                                                style={{marginTop: '-8px'}}
                                                                aria-describedby="tooltip-email"
                                                                aria-label="Inserisci l’indirizzo email che hai fornito al tuo gestore di filiale per l’apertura della richiesta di mutuo"
                                                            />
                                                        </Tooltip>
                                                        
                                                    </Space>
                                                </span>
                                                
                                                }
                                                >
                                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                    <Input
                                                        type="email"
                                                        name="mail"
                                                        value={this.state.mail}
                                                        placeholder="Inserisci il tuo indirizzo email"
                                                        onChange={e => this.setState({ mail: e.target.value })}
                                                        aria-describedby="tooltip-email"
                                                    />                                                    
                                                    
                                                </div>
                                            </Form.Item>
                                            <Form.Item style={{ marginBottom: '8px!important' }}>
                                                <Row>
                                                    <Col span={18} style={{ marginTop: '5px' }} tabIndex={0}>E' il tuo primo accesso o hai dimenticato il codice? Richiedilo nuovamente</Col>
                                                    <Col span={6} style={{ textAlign: 'right' }}>
                                                        <Button type="primary" block shape="round"
                                                            className={`my-button ${this.state.IsCodeRequestedStep1 ? 'disabled' : ''}`}
                                                            aria-disabled={this.state.IsCodeRequestedStep1}
                                                            onClick={this.richiediPassword}>Richiedi codice</Button>
                                                    </Col>
                                                    <div
                                                        ref={this.statusRichiestaCodice}
                                                        role="status"
                                                        className="visually-hidden"
                                                    ></div>
                                            </Row>
                                            </Form.Item>
                                            <Form.Item htmlFor="otp" label={
                                                <span style={{ display: 'inline-flex', alignItems: 'center'}}>
                                                    <Space>
                                                        <h3 style={{ marginTop: '6px' }}>Codice di accesso</h3>
                                                        <Tooltip title="Inserisci il codice di accesso che hai ricevuto tramite SMS. Se non hai a disposizione il codice di sicurezza puoi chiederne uno nuovo selezionando la voce “Richiedi un nuovo codice di accesso”" trigger={['hover', 'focus']}>
                                                            <Button
                                                                type="text"
                                                                icon={<img src={info_grey} height="15" alt="Informazioni sul codice di accesso" />}
                                                                tabIndex={0} // Assicura che sia focusable
                                                                style={{ marginTop: '-8px' }}
                                                                aria-describedby="tooltip-password"
                                                                aria-label="Inserisci il codice di accesso che hai ricevuto tramite SMS. Se non hai a disposizione il codice di sicurezza puoi chiederne uno nuovo selezionando la voce “Richiedi un nuovo codice di accesso”"
                                                            />

                                                        </Tooltip>
                                                    </Space>
                                                </span>
                                                }>
                                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                    <Input
                                                        type={this.state.showPassword ? "text" : "password"}
                                                        name="otp"
                                                        value={this.state.password}
                                                        placeholder="Inserisci il codice di accesso"
                                                        onChange={e => this.setState({ password: e.target.value })}
                                                        aria-describedby="tooltip-password"
                                                    />
                                                    <span
                                                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                        style={{
                                                            position: 'absolute',
                                                            right: 10,
                                                            cursor: 'pointer',
                                                            color: '#888'
                                                        }}
                                                        tabIndex={0}
                                                        aria-label={this.state.showPassword ? "Nascondi codice" : "Mostra codice"}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                this.setState({ showPassword: !this.state.showPassword });
                                                            }
                                                        }}
                                                    >
                                                        {this.state.showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                                    </span>
                                                </div>
                                               
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                                
                                <Button type="primary" shape="round" block onClick={this.login}>Accedi</Button>
                            </div>
                            :
                            <div>
                                <Row>
                                    <Col >
                                        <h1 className="Bold20Credem400" style={{ marginBottom: '20px' }}>Accesso</h1>
                                    </Col>
                                </Row>
                                <Row justify="center"  >
                                    <Col span="24" tabIndex={0}>
                                        Per accedere richiedi il codice che riceverai via email e inseriscilo qui sotto.
                                    </Col>
                                </Row>
                                <div style={{ margin: '8px 0' }} aria-hidden="true" />
                                <Row>
                                    <Col span={11}>
                                        <Button
                                            className={`my-button ${this.state.IsCodeRequested ? 'disabled' : ''}`}
                                            aria-disabled={this.state.IsCodeRequested}
                                            type="primary" shape="round"
                                            block
                                            onClick={this.request2fa}
                                        >
                                            Richiedi codice via email
                                        </Button>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={12}>
                                        <Input
                                            className={`my-button ${!this.state.IsCodeRequested ? 'disabled' : ''}`}
                                            aria-disabled={!this.state.IsCodeRequested}
                                            name="2facode"
                                            placeholder="Inserisci qui il codice"
                                            value={this.state.code}
                                            onChange={e => this.setState({ code: e.target.value })}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div
                                            ref={this.statusRef}
                                            role="status"
                                            style={{ marginTop: '8px', marginBottom: '8px' }}
                                        ></div>
                                        {/*{this.state.IsCodeRequested && (*/}

                                        {/*        Il tuo codice è stato inviato alla mail indicata in fase di login*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                    </Col>
                                </Row>
                                <Button type="primary" shape="round" block
                                    onClick={this.verifica2fa}
                                    className={`my-button ${!this.state.IsCodeRequested ? 'disabled' : ''}`}
                                    aria-disabled={!this.state.IsCodeRequested}
                                >ACCEDI</Button>

                            </div>
                            }
                            
                    </Card>                    
                </Col>               
            </Row>
        )
    }
}